













import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from './components/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '1018GYPMGG';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动简介',
      path: `/${baseUrl}/rules`,
      id: 1,
    },
    {
      title: '点赞投票<br />（成人组）',
      path: `/${baseUrl}/people`,
      id: 2,
    },
    {
      title: '点赞投票<br />（青少年组）',
      path: `/${baseUrl}/list`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  async onRouteChange() {
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2023两江新区公益广告平面设计大赛',
      url: location.href,
      subtitle: `2023两江新区公益广告平面设计大赛`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2023两江新区公益广告平面设计大赛',
        subtitle: `2023两江新区公益广告平面设计大赛`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
